import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteExercise } from "../../../api/endpoints/ExerciseEndpoints";

export default function useDeleteExercise() {
  return useMutation<void, AxiosError, { exerciseId: number }>({
    mutationKey: ["delete-exercise"],
    mutationFn: ({ exerciseId }) => deleteExercise(exerciseId),
  });
}
